<template>
  <div
    class="horizontal-nav flex pb-10 pt-10 fixed-top justify-space-between"
    :class="{ ['pos-' + position]: true }"
  >
    <logo mode="horizontal" />
    <div v-if="termsAccepted" class="box grow flex nav-container">
      <div class="box grow">
        <Nav @push-page="pushPage" mode="horizontal"></Nav>
      </div>
    </div>
    <div class="box-logo flex align-center">
      <toolbar class="toolbar-display"></toolbar>
    </div>
  </div>
</template>

<script>
import Nav from "@/core/nav.vue";
import Logo from "@/core/logo.vue";
import Toolbar from "@/core/toolbar.vue";

export default {
  name: "HorizontalNav",
  components: {
    Nav,
    Logo,
    Toolbar,
  },
  props: ["position"],
  data() {
    return {};
  },
  computed: {
    termsAccepted() {
      return this.$store.getters.termsAndConditionsAccepted;
    },
  },
  methods: {
    pushPage(index, indexPath) {
      this.$emit("push-page", { page: index });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";

.toolbar-display {
  margin-bottom: 18px;
}

@media screen and (max-width: 1240px) {
  .toolbar-display {
    display: none;
  }
}

.horizontal-nav {
  max-width: 1900px;
  margin-left: auto;
  margin-right: auto;

  overflow: hidden;
  background: white;
  height: 70px;
  z-index: 1000;
  border-bottom: 10px solid $background-color;

  &.pos-top {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
  &.pos-bottom {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  .nav-container {
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      display: block;
      z-index: 1;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 0px;
      height: 20px;
    }
    &::after {
      content: "";
      display: block;
      z-index: 1;
      position: absolute;
      top: 0px;
      right: 20px;
      width: 0px;
      height: 20px;
    }
  }
}
</style>
